import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../contexts/SubscriptionContext';
import { AlertTriangle, X } from 'lucide-react';
import { Button } from './ui/button';
import { useTranslation } from 'react-i18next';

const GraceBanner = () => {
  const { isInGracePeriod, graceDaysRemaining } = useSubscription();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('grace_banner_dismissed') === 'true');
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!isInGracePeriod() || dismissed) return null;

  const days = graceDaysRemaining();

  const handleDismiss = () => {
    sessionStorage.setItem('grace_banner_dismissed', 'true');
    setDismissed(true);
  };

  return (
    <div className="bg-yellow-50 dark:bg-yellow-900/20 border-b border-yellow-200 dark:border-yellow-800 px-4 py-2 flex items-center justify-between gap-2">
      <div className="flex items-center gap-2 text-sm text-yellow-800 dark:text-yellow-200">
        <AlertTriangle className="w-4 h-4 shrink-0" />
        <span>
          {t('grace.payment_failed', 'Payment failed \u2014 update your payment method.')}
          {' '}
          <strong>{t('grace.days_remaining', '{{days}} days remaining', { days })}</strong>
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="outline" onClick={() => navigate('/subscription')} className="text-xs">
          {t('grace.update_payment', 'Update Payment')}
        </Button>
        <button onClick={handleDismiss} className="min-h-[44px] min-w-[44px] md:min-h-0 md:min-w-0 flex items-center justify-center text-yellow-600 hover:text-yellow-800 active:bg-yellow-100/50 rounded" aria-label={t('common.dismiss', 'Dismiss')}>
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default GraceBanner;
